import { SessionStorage } from "./sessionStorage";

class MsgTokenStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "msg_token",
		});
	}
}

export const msgTokenStorage = new MsgTokenStorage();
